// extracted by mini-css-extract-plugin
export default {"cls1":"UserTooltip-cls1__c556a51c1020c9ea0531","cls2":"UserTooltip-cls2___b1ec345ee092aaed838 UserTooltip-cls1__c556a51c1020c9ea0531"};